"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Makes requests using the fetch API
 */
var FetchClient = (function () {
    function FetchClient() {
    }
    FetchClient.prototype.fetch = function (url, options) {
        return global.fetch(url, options);
    };
    return FetchClient;
}());
exports.FetchClient = FetchClient;



//////////////////
// WEBPACK FOOTER
// ./~/sp-pnp-js/lib/net/fetchclient.js
// module id = 10
// module chunks = 0